import { Flex, H4, P, Space, Table, Th, Tr } from '@dnb/eufemia';
import { Form, Iterate, Wizard } from '@dnb/eufemia/extensions/forms';
import { ApiDto } from '@portals/shared/portal/ApiDto';
import { AppApiEntitlementRequestSchemaV2Form } from '@portals/shared/portal/AppApiEntitlementDto';

import Divider from '@/components/Divider';

import ScopeEnvSelectItem from './ScopeEnvSelectItem';

type EditScopesProps = {
  api: ApiDto;
  formId: string;
};

export default function EditScopes({ api, formId }: EditScopesProps) {
  const { data } = Form.useData<AppApiEntitlementRequestSchemaV2Form>(formId);
  return (
    <Form.Card>
      <H4>{api.name}</H4>
      <P top="small">{api.description}</P>
      <Space bottom="x-small" top="x-small">
        <Divider />
      </Space>

      <Table>
        <thead>
          <Tr>
            <Th style={{ width: '100%' }}>Scope</Th>
            <Th style={{ minWidth: 90 }}>Test</Th>
            <Th style={{ minWidth: 90 }}>Live</Th>
          </Tr>
        </thead>
        <tbody>
          <Iterate.Array path="/scopes" withoutFlex>
            {(_, itemIndex) => {
              return <ScopeEnvSelectItem itemIndex={itemIndex} liveAccessEnabled={api.availableInLiveMode} />;
            }}
          </Iterate.Array>
        </tbody>
      </Table>

      <Flex.Horizontal>
        <Wizard.PreviousButton />
        <Wizard.NextButton disabled={!data.scopes.some((scope) => scope.test || scope.live)} />
      </Flex.Horizontal>
    </Form.Card>
  );
}
